import styled from 'styled-components';

export const ExchangeRightsStyles = styled.div`
	width: 100%;

	.separator {
		border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		padding: 0.25rem 1rem;
		text-transform: uppercase;
		color: ${({ theme }) => theme.v3.colors.gray[9]};
	}
`;
